import React from 'react';

import { IconPropTypes } from 'ggApp/types/propTypes';

const Share = ({ color, size, className }) => (
    <svg
        className={className}
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3 18L3 10L5 10L5 18C5 18.5523 5.44772 19 6 19L18 19C18.5523 19 19 18.5523 19 18L19 10L21 10L21 18C21 19.6569 19.6569 21 18 21L6 21C4.34315 21 3 19.6569 3 18Z"
            fill={color}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.0009 1.58494L16.4485 6.03254C16.839 6.42306 16.839 7.05623 16.4485 7.44675C16.058 7.83728 15.4248 7.83728 15.0343 7.44675L13.0009 5.41337L13.0009 14.9992L11.0009 14.9992L11.0009 5.41337L8.9675 7.44675C8.57697 7.83728 7.94381 7.83728 7.55328 7.44675C7.16276 7.05623 7.16276 6.42306 7.55328 6.03254L12.0009 1.58494Z"
            fill={color}
        />
    </svg>
);

Share.propTypes = {
    ...IconPropTypes,
};

Share.defaultProps = {
    color: 'rgba(51, 51, 51, 51)',
    size: '24px',
};

export default Share;
